// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__KCSBo","header":"ReportDetails_header__1dqvk","title":"ReportDetails_title__5mUuN","left":"ReportDetails_left__pjWgr"};